import { render } from "./VButton.vue?vue&type=template&id=c826fbca&scoped=true"
const script = {}

import "./VButton.vue?vue&type=style&index=0&id=c826fbca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c826fbca"]])

export default __exports__